import {SizeSelection_Size} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {ProductTrackingData, getAdditionalBasketData} from '@aboutyou/tracking';
import {
  AddToBasketTrackingData,
  BasketMutationError,
  BasketMutationSuccess,
  useAddToBasketMutation,
} from '@aboutyou/user';
import {SizeSource} from '../../SizeSelection/hooks/useSelectedSizeState';

interface AddToBasketProps {
  size: SizeSelection_Size & SizeSource;
  productId: number;
  captchaCode?: string;
  sponsoredType?: string;
  couponPromotionId?: string | null;
  skipFreeDeliveryMovSection?: boolean;
  overrideBETrackingData?: AddToBasketTrackingData;
}

export interface AddToBasketOnSuccessProps
  extends Omit<BasketMutationSuccess, 'failed'> {
  size?: SizeSelection_Size;
}

interface UseAddToBasketProps {
  onSuccess: (props: AddToBasketOnSuccessProps) => void;
  onError: (err: BasketMutationError) => void;
  trackingData?: ProductTrackingData & {brandName: string};
  badgesListKeys: string[];
}

export const useAddToBasket = ({
  onSuccess,
  onError,
  trackingData,
  badgesListKeys,
}: UseAddToBasketProps) => {
  const addToBasketRequest = useAddToBasketMutation({
    trackingDataGA: {
      ...trackingData,
      brandName: trackingData?.brandName || '',
      badges: badgesListKeys,
    },
  });

  const addToBasket = async ({
    size,
    productId,
    captchaCode,
    sponsoredType,
    couponPromotionId,
    skipFreeDeliveryMovSection,
    overrideBETrackingData,
  }: AddToBasketProps) => {
    const getCustomData = getAdditionalBasketData();

    const customData =
      getCustomData &&
      getCustomData({
        productId,
        variantId: size.sizeId,
        productSponsoredType: sponsoredType,
      });

    try {
      const response = await addToBasketRequest({
        productId,
        sizeId: size?.sizeId,
        sizeSource: size.sizeSource,
        captchaCode,
        trackingDataBE: {
          ...customData,
          ...overrideBETrackingData,
        },
        couponPromotionId,
        skipFreeDeliveryMovSection,
      });

      if (response?.failed) {
        onError(response);
      } else {
        const successResponse = response as BasketMutationSuccess;
        onSuccess({
          size,
          freeDeliverySection: successResponse?.freeDeliverySection,
          statusSuccessSections: successResponse.statusSuccessSections,
        });
      }
    } catch (error) {
      onError(error);
    }
  };

  return addToBasket;
};
